// extracted by mini-css-extract-plugin
module.exports = {"container":"Select_container__eGYSN","select":"Select_select__TaKl3","icon":"Select_icon__bBfSH"};